var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictogramPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M0 .001h46.804v48.154H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M0 48.155h46.805V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "C",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    opacity: 0.3,
    fill: "#d8d8d8",
    mask: "url(#C)",
    d: "M1 18h44.46l.668 21.2h-7.044v-7.958H6.46V39H1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M8.537 10.414l.16.387h6.83a1.13 1.13 0 0 0 1.127-1.128V2.846l-.387-.16-7.728 7.73zm-1.34 6.688h31.06V2.473a1.13 1.13 0 0 0-1.129-1.127H18v8.328c0 1.365-1.1 2.474-2.474 2.474H7.198v4.955zM38.93 30.605c.372 0 .673.303.673.674v7.43h5.856v-19.13a1.13 1.13 0 0 0-1.128-1.128H2.474a1.13 1.13 0 0 0-1.129 1.128v19.13H5.85v-7.43c0-.37.3-.674.673-.674H38.93zM7.198 46.808h31.06V31.952H7.198v14.856zm-.674 1.346c-.372 0-.673-.3-.673-.672v-7.43H.674c-.372 0-.674-.302-.674-.673V19.577a2.48 2.48 0 0 1 2.475-2.474H5.85v-5.628a.67.67 0 0 1 .197-.476L16.85.198c.127-.128.295-.197.476-.197H37.13c1.364 0 2.474 1.11 2.474 2.473v14.63h4.728c1.364 0 2.473 1.1 2.473 2.474V39.38c0 .37-.3.673-.672.673h-6.53v7.43c0 .37-.3.672-.673.672H6.524z",
    fill: "#000",
    mask: "url(#C)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  })), /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M40.308 23.116h1.224V21.9h-1.224v1.225zm1.837 1.224h-2.45a.61.61 0 0 1-.612-.612v-2.45a.61.61 0 0 1 .612-.613h2.45a.61.61 0 0 1 .612.613v2.45a.61.61 0 0 1-.612.612zm-12.95 18.7h-17.24c-.477 0-.862-.328-.862-.73s.385-.73.862-.73h17.24c.477 0 .862.327.862.73s-.385.73-.862.73M20.45 39.2h-8.5c-.47 0-.852-.328-.852-.73s.38-.73.852-.73h8.5c.47 0 .852.327.852.73s-.38.73-.852.73",
    mask: "url(#D)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramPrinter);
export default __webpack_public_path__ + "static/media/pictogram-printer.a5b52602d5fd7bca1cc2450754f9316b.svg";
export { ForwardRef as ReactComponent };